import * as React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useGetDogovorsQuery } from "../../../store/dogovorApi";
import { convertToRuFormat } from "../../../utilits/helpers/convertDateFormat";
import {useGetPaymentCodeQuery} from '../../../store/paymentCodeApi'

function Row({ row, paymentCode }) {
  const [openFirst, setOpenFirst] = React.useState(false);

  const paymentIsTrue = row.attributes.payments.data.filter(
    (item) =>
      item.attributes.checked === true &&
      item.attributes.payment_code.data[0].attributes.code === paymentCode
  );
  const totalAmountOfPayment = paymentIsTrue.reduce(
    (sum, current) => sum + current.attributes.amount,
    0
  );

  const schedulesFromToday = row.attributes.schedule.filter(
    (item) => new Date(item.paymentDate) < new Date()
  );
  const totalAmountOfSchedule = schedulesFromToday.reduce(
    (sum, current) => sum + Number(current.amount),
    0
  );

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpenFirst(!openFirst)}
          >
            {openFirst ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.attributes.contragent.data[0].attributes.surname +
            " " +
            row.attributes.contragent.data[0].attributes.name +
            " " +
            row.attributes.contragent.data[0].attributes.lastname}
        </TableCell>
        <TableCell align="center">№{row.attributes.numberDogovor}</TableCell>
        <TableCell align="center">{row.attributes.totalSum}</TableCell>
        <TableCell align="center">{totalAmountOfSchedule.toFixed(3)}</TableCell>
        <TableCell align="center">{totalAmountOfPayment.toFixed(3)}</TableCell>
        <TableCell
          align="right"
          sx={{
            color:
            totalAmountOfSchedule < totalAmountOfPayment ? "blue" : totalAmountOfSchedule > totalAmountOfPayment ? "red" : "green",
          }}
        >
          {(totalAmountOfSchedule - totalAmountOfPayment).toFixed(3)}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={openFirst} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                График оплаты
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Дата оплаты</TableCell>
                    <TableCell>Сумма оплаты</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.attributes.schedule.map((sched) => (
                    <TableRow key={sched.paymentDate}>
                      <TableCell component="th" scope="row">
                        {convertToRuFormat(sched.paymentDate)}
                      </TableCell>
                      <TableCell>{sched.amount}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function CollapsibleTable() {
  const { data: dogovorsFB } = useGetDogovorsQuery(
    "?sort[0]=id:asc&populate[1]=contragent&populate[2]=nomenklatura&populate[3]=payments.payment_code",
    { refetchOnMountOrArgChange: true }
  );
  const { data: paymentCodesFB } = useGetPaymentCodeQuery("/1");
  const [rows, setRows] = React.useState([]);
  const [arendaCode, setArendaCode] = React.useState({});

  React.useEffect(() => {
    const setDataToStates = async () => {
      try {
        const dogovors = await dogovorsFB.data;
        const paymentCode = await paymentCodesFB.data;
        setRows(dogovors);
        setArendaCode(paymentCode);
      } catch (error) {}
    };
    setDataToStates();
  }, [dogovorsFB, paymentCodesFB]);

  return (
    <>
      <div style={{ margin: "20px 0 20px 20px" }}>
        <Typography variant="h5" gutterBottom component="div">
          Сформирован на: {convertToRuFormat(new Date())}
        </Typography>
      </div>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>
                <Typography variant="h5" gutterBottom component="div">
                  Контрагент
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h5" gutterBottom component="div">
                  Договор
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h5" gutterBottom component="div">
                  Сумма
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h5" gutterBottom component="div">
                  Начислено
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h5" gutterBottom component="div">
                  Оплачено
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography variant="h5" gutterBottom component="div">
                  Задолженность
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <Row key={row.id} row={row} paymentCode={arendaCode.attributes.code}/>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
